import { MainPageContainer, UpperInfoContainer } from 'components/PageLayout';
import { useMonthlyNotificationVolumeReport } from 'pages/hooks';
import { useMemo } from 'react';
import { AxiosError } from 'axios';
import { errorMessages } from 'api/resources/responseMessages/errorMessages';
import { ReportHeader } from 'components/ReportsComponents/ReportHeader';
import { ReportBackButton } from 'components/ReportsComponents/ReportBackButton';
import { NoReportDataMessage } from 'components/ReportsComponents/NoReportDataMessage';
import { ReportGridContainer } from 'components/ReportGridContainer';
import {
  NOTIFICATION_VOLUME_REPORT,
  NOTIFICATION_VOLUME_REPORT_HEADER_TAG_LINE,
  NOTIFICATION_VOLUME_REPORT_MESSAGE,
  NOTIFICATION_VOLUME_REPORT_TITTLE,
  columns,
} from './constants';
import { ReportProps } from 'pages/ReportsDetails/types';
import { reportLogger } from 'pages/ReportsDetails/reportLogger';
import DevExtremeReportGrid from 'components/ReportGrid_New';

export function MonthlyNotificationVolume({
  setErrorMessage,
  setToast,
}: Readonly<ReportProps>) {
  const { isReportFetching, reportData } =
    useMonthlyNotificationVolumeReport(handleError);

  const rows = useMemo(() => reportData, [reportData]);
  return (
    <MainPageContainer isLoading={false} direction="column" wrap="nowrap">
      <UpperInfoContainer direction="column">
        <ReportBackButton />
        <ReportHeader
          reportName={NOTIFICATION_VOLUME_REPORT}
          infoMessage={NOTIFICATION_VOLUME_REPORT_MESSAGE}
        />
      </UpperInfoContainer>

      {!isReportFetching && rows?.length === 0 && <NoReportDataMessage />}

      <ReportGridContainer direction="column">
        <DevExtremeReportGrid
          columns={columns}
          displayGroupingPanel
          headerTitleForSheet={NOTIFICATION_VOLUME_REPORT}
          isLoading={isReportFetching}
          reportHeaderTagLine={NOTIFICATION_VOLUME_REPORT_HEADER_TAG_LINE}
          rows={rows}
          title={NOTIFICATION_VOLUME_REPORT_TITTLE}
        />
      </ReportGridContainer>
    </MainPageContainer>
  );

  function handleError(error: AxiosError) {
    reportLogger(error);
    setErrorMessage(errorMessages.reports(NOTIFICATION_VOLUME_REPORT));
    setToast(true);
  }
}
